/**
 * 历史记录条目组件
 * zxw
 * 2024-04-03
 */

import { useState } from 'react';
import { Button, Input, Row, Col, message, Popover } from 'antd';
import {
    StarOutlined, BlockOutlined,
    EditOutlined, DeleteOutlined,
    CheckOutlined, CloseOutlined,
    InfoCircleOutlined,
} from '@ant-design/icons';
import $ from 'jquery';
import { AddRequestHeaders } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const HistoryEntry = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isHover, setIsHover] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [showTitle, setShowTitle] = useState(props.data.title);
    const [title, setTitle] = useState(props.data.title);
    const [delOpen, setDelOpen] = useState(false);

    /**
     * 收藏
     * @returns
     */
    const collect = () => {
        $.ajax({
            url: `${CNF.api}dialogues/${props.data.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'is_collect': props.data.is_collect === '否' ? '是' : '否',
            }), success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        props.getDialogues();
                    }, CNF.messageDuration * 1000);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 标星
     * @returns
     */
    const star = () => {
        $.ajax({
            url: `${CNF.api}dialogues/${props.data.key}`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'is_star': props.data.is_star === '否' ? '是' : '否',
            }), success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        props.getDialogues();
                    }, CNF.messageDuration * 1000);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 删除
     */
    const doDelete = () => {
        $.ajax({
            url: `${CNF.api}dialogues/${props.data.key}`,
            headers: AddRequestHeaders(),
            type: 'DELETE',
            success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setTimeout(function () {
                        props.getDialogues();
                        if (props.data.key === props.dialogueUlid) {
                            // 如果删除的是当前选中的对话，则清空会话内容
                            props.newSession();
                        }
                    }, CNF.messageDuration * 1000);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /**
     * 更新标题
     * @returns 
     */
    const update = () => {
        //  参数校验
        if (title === '') {
            messageApi.error('标题不能为空！');
            return;
        }
        $.ajax({
            url: `${CNF.api}dialogues/${props.data.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'title': title,
            }), success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                    setShowTitle(title);
                    setIsEdit(false);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    return <>
        {contextHolder}
        {
            isEdit ?
                <div style={{
                    width: '100%',
                    height: 40,
                    margin: '5px 0',
                    borderRadius: 5,
                }}
                ><div style={{
                    display: 'inline-block',
                    width: 'calc(100% - 45px)',
                }}>
                        <Input
                            value={title}
                            onChange={(e) => { setTitle(e.target.value) }}
                        />
                    </div>
                    <div style={{
                        padding: '0 5px',
                        height: 40,
                        width: 45,
                        lineHeight: '40px',
                        display: 'inline-block',
                    }}>
                        <Row>
                            <Col span={12}>
                                <Button type='link' style={{
                                    width: '100%',
                                }}
                                    onClick={(e) => {
                                        update();
                                        e.preventDefault();
                                    }} icon={<CheckOutlined />} />
                            </Col>
                            <Col span={12}>
                                <Button type='link' style={{
                                    width: '100%',
                                }}
                                    onClick={(e) => {
                                        setIsEdit(false);
                                        e.preventDefault();
                                    }} icon={<CloseOutlined />} />
                            </Col>
                        </Row>
                    </div>
                </div>
                :
                <div style={{
                    width: '100%',
                    margin: '5px 0',
                    height: 40,
                    padding: '10px',
                    borderRadius: 5,
                    cursor: 'pointer',
                    position: 'relative',
                    color: props.data.key === props.dialogueUlid ? '#fff' : '#000',
                    // fontWeight: props.data.key===props.dialogueUlid?'bold':'normal',
                    backgroundColor: props.data.key === props.dialogueUlid ? global.THEMECOLOR : isHover ? '#F8F8FA' : '#fff',
                }}
                    onMouseEnter={() => { setIsHover(true) }}
                    onMouseLeave={() => { setIsHover(false); setTimeout(() => { setDelOpen(false); }, 1000); }}
                    onClick={(e) => {
                        if (e.target.tagName.toLowerCase() === 'div') {
                            props.getDialogueContents(props.data.key, props.data.conversation_id);
                        }
                        e.preventDefault();
                    }}
                ><div style={{
                    width: isHover ? 'calc(100% - 90px)' : '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>{showTitle}</div>
                    <div style={{
                        position: 'absolute',
                        padding: '0 5px',
                        top: 0,
                        right: 0,
                        height: 40,
                        width: 90,
                        lineHeight: '40px',
                        background: '#F8F8FA',
                        display: isHover ? 'block' : 'none',
                    }}>
                        <Row>
                            <Col span={6}>
                                <Button type='link' style={{
                                    width: '100%',
                                }}
                                    onClick={(e) => {
                                        setIsEdit(true);
                                        e.preventDefault();
                                    }} icon={<EditOutlined />} />
                            </Col>
                            <Col span={6}>
                                <Button type='link' style={{
                                    width: '100%',
                                    color: props.data.is_collect === '是' ? '#FF904D' : '',
                                }}
                                    onClick={(e) => {
                                        collect();
                                        e.preventDefault();
                                    }} icon={<BlockOutlined />} />
                            </Col>
                            <Col span={6}>
                                <Button type='link' style={{
                                    width: '100%',
                                    color: props.data.is_star === '是' ? '#FF904D' : '',
                                }}
                                    onClick={(e) => {
                                        star();
                                        e.preventDefault();
                                    }} icon={<StarOutlined />} />
                            </Col>
                            <Col span={6}>
                                <Popover
                                    placement="bottomRight"
                                    title={<><InfoCircleOutlined
                                        style={{ color: '#FF904D', marginRight: 5 }} />删除后无法恢复，确认删除该会话吗？</>}
                                    content={<>
                                        <div style={{ textAlign: 'right' }}>
                                            <Button style={{ marginRight: 10 }} onClick={(e) => {
                                                setDelOpen(false);
                                                e.preventDefault();
                                            }}>取消</Button>
                                            <Button danger onClick={(e) => {
                                                doDelete();
                                                setDelOpen(false);
                                                e.preventDefault();
                                            }}>确认</Button>
                                        </div>
                                    </>}
                                    open={delOpen}
                                >
                                    <Button type='link' style={{
                                        width: '100%',
                                    }}
                                        onClick={(e) => {
                                            setDelOpen(true);
                                            e.preventDefault();
                                        }} icon={<DeleteOutlined />} />
                                </Popover>
                            </Col>
                        </Row>
                    </div>
                </div>
        }
    </>
}

export default HistoryEntry;